import React from 'react'
import {Card, CardBody, CardFooter, Row, Col, Button, ButtonGroup} from 'reactstrap'
import icon from '../../assets/img/icons/zapier-icon.png'

export default function ZapierConnection() {

  return (
    <>
    <Card>
      <CardBody className="text-center">
        <div className="card-avatar avatar avatar-lg mx-auto">
          <img src={icon} alt="Zapier Connection" className="avatar-img rounded"/>
        </div>
        <h2 className="mb-3">Zapier</h2>
        <a name="mailerlite-learn-more" className="btn btn-primary btn-sm" target="_blank" href={"https://justcast.zendesk.com/hc/en-us/articles/10289084300180-Connect-JustCast-to-Zapier"}>Learn more</a>
      </CardBody>
      <CardFooter className="card-footer-boxed">              
        <Row className="align-items-center justify-content-between">
          <div className="col-auto"/>
          <div className="col-auto">
            <a name="connect" className="btn btn-primary btn-sm" target="_blank" href="https://zapier.com/apps/justcast/integrations">Connect</a>
          </div>
        </Row>
      </CardFooter>
    </Card>
    </>
  )
}
